// removed by extract-text-webpack-plugin
module.exports = {"Purchase":"Purchase__Purchase__2ua4o"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Tracker/PurchaseHistory/Purchase/Purchase.css
// module id = 68
// module chunks = 0